import client from "./base"
import { ProductInAllPharmacy } from "../models/product-all-pharmacy";

export type IGetProductInAllPharmacy = {
    adminId: string,
    filter: {
        offset: number,
        limit: number,
        skip: number,
        order: string,
        where?: {
            [key: string]: {}
        },
    }
}

export type IGetCountProductInAllPharmacy = {
    adminId: string,
    where: {
        [key: string]: {}
    }
}

export const getProductInAllPharmacy = async (params: IGetProductInAllPharmacy) => {
    const { adminId, filter } = params

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/inventory-items`
    try {
        let fetchResults = await client.get(
            path,
            { params: { filter } }
        )


        let listProduct = [];

        listProduct = fetchResults.data.map((product: any) => {
            return {
                ...new ProductInAllPharmacy({
                    ...product,
                })
            }
        })

        return {
            listProduct,
        }
    } catch (err) {
        console.error("error on fetch inv items: ", err);
        return {
            listProduct: [],
        }
    }
}

export const getCountProductInAllPharmacy = async (params: IGetCountProductInAllPharmacy) => {
    const { adminId, where } = params

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/inventory-items/count`
    try {
        let fetchResults = await client.get(
            path,
            { params: { where } }
        )

        return {
            total: fetchResults.data.count
        }
    } catch (err) {
        console.error("error on fetch inv items: ", err);
        return {
            total: 0
        }
    }
}